import { FeedbackWrapper } from 'components/FeedbackWrapper';
import DefaultLayout from 'layouts/defaultLayout';
import type { FC } from 'react';

const Referred: FC = () => (
  <DefaultLayout renderStepper={false} verticalCentered extendContainer>
    <FeedbackWrapper
      feedback="referred"
      title="Almost there!"
      subtitle="We need to learn a few more things about your business so we are able to give you the best price."
    />
  </DefaultLayout>
);

export default Referred;
